import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

import { computed, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { getCurrentShapeInputComponent } from "@/components/shapes/ShapeHelper";
import ValidationMessage from "./UI/ValidationMessage.vue";
import MessageContainer from "@/components/UI/MessageContainer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShapeInputs',
  setup(__props) {

const store = useStore();
const shape = computed(() => store.getters.shape);
const dimensions = computed(() => store.getters.dimensions);
const modifiers = computed(() => store.getters.modifiers);
const hasGroupedDimensionValidatorErrors = computed(
	() => store.getters.hasGroupedDimensionValidatorErrors
);
const getGroupedDimensionValidationMessage = computed(
	() => store.getters.getGroupedDimensionValidationMessage
);
const hasProblematicCorners = computed(() => store.getters.hasProblematicCorners);
const validationDimensionMessages = computed(() => {
	const validators = store.getters.getDimensionValidatorErrors;
	return validators.map((validator) => {
		return {
			key: validator.field,
			id: `measurements-${validator.field}`,
			message: validator.getMessage(),
		};
	});
});

document.addEventListener('focusin', (event) => store.commit('updateFocusedElement', event));
document.addEventListener('focusout', () => store.commit('updateFocusedElement', ''));

onBeforeUnmount(() => {
	document.removeEventListener('focusout', () => store.commit('updateFocusedElement'));
	document.removeEventListener('focusin', () => store.commit('updateFocusedElement'));
});

const currentProps = computed(() => {
	switch (shape.value) {
		case "rectangle":
		case "rounded-rectangle":
		case "circle":
		case "half-circle":
		case "quarter-circle":
		case "egg":
		case "ellipse":
		case "flat-oval":
		case "sloped-rectangle":
		case "sloped-rectangle-flip-horizontal":
		case "sloped-right-rectangle":
		case "sloped-right-rectangle-flip-vertical":
		case "right-angled-triangle":
		case "right-angled-triangle-mirrored":
		case "isosceles-triangle":
		case "trapezoid":
		case "hexagon":
		case "octagon":
		case "polygon":
		case "heart":
		case "arrow":
		case "star":
		case "text":
		case "droplet":
		case "kite":
		case "barrel":
		case "jewel":
		case "parallelogram-flip-horizontal":
		case "parallelogram":
		case "arched-rectangle":
			return {
				action: "updatePlateDimension",
				modifierAction: "updateModifier",
				isCutout: false,
				prefix: '',
			};
		default:
			return {
				value: dimensions.value,
				modifiers: modifiers.value,
			};
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getCurrentShapeInputComponent)(shape.value)), _normalizeProps(_guardReactiveProps(currentProps.value)), null, 16)),
    _createVNode(MessageContainer, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationDimensionMessages.value, (field) => {
          return (_openBlock(), _createBlock(ValidationMessage, {
            key: field.key + '-validation-message',
            "input-id": field.id
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(field.message), 1)
            ]),
            _: 2
          }, 1032, ["input-id"]))
        }), 128)),
        (hasProblematicCorners.value)
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 0,
              type: "notice"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$i18n.problematicCornersNotice), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (hasGroupedDimensionValidatorErrors.value)
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 1,
              "input-id": "grouped-validation-message"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getGroupedDimensionValidationMessage.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})